/*@ngInject*/
const DeleteAttachmentRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteAttachment = function (attachmentId, fieldId) {
        let url = '/rest/UnderwritingAttachment/' + attachmentId;

        if (fieldId) {
            url += '?fieldId=' + fieldId;
        }

        return this.delete(url);
    };
};

angular.module('umCore')
    .service('deleteAttachmentRepository', DeleteAttachmentRepository);
